import React from "react";

const UserManagementContext = React.createContext({});

export default UserManagementContext;
